import * as React from 'react'

/**
 * The last marker of a stack holding more scans than it can draw.
 *
 * Carries the number it stands for, itself included, in place of a tracking glyph - the design caps
 * a stack at three markers so a burst of twenty does not smear down the month.
 */
export default ({ count }) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9.5" cy="9.5" r="8.5" fill="#001335" stroke="var(--bg-color-timelineV2)" strokeWidth="2" />
    <text
      x="9.5"
      y="9.5"
      textAnchor="middle"
      dominantBaseline="central"
      fill="white"
      fontFamily="Dazzed, sans-serif"
      fontSize={count >= 100 ? 6 : 7}
      fontWeight="600"
    >
      +{count}
    </text>
  </svg>
)
